import { render, staticRenderFns } from "./OptionsSlider.vue?vue&type=template&id=4cfc6fbf"
import script from "./OptionsSlider.vue?vue&type=script&lang=js"
export * from "./OptionsSlider.vue?vue&type=script&lang=js"
import style0 from "./OptionsSlider.vue?vue&type=style&index=0&id=4cfc6fbf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports